import Container from "@components/Container/Container";
import Edition from "@features/banner/Edition/Edition";

import LogoMasthead from "./LogoMasthead/LogoMasthead";
import type { NavigationA } from "./types";

export type MastheadProps = {
  prefix?: string;
  mastheadTitle?: string;
  mastheadCustomElement?: React.ReactElement;
  userDisplayName?: boolean;
  mastheadLinks?: NavigationA;
};

export default function HomepageMasthead() {
  return (
    <Container rootClassName="py-5 hidden lg:block">
      <Edition className="mb-2 text-center uppercase" />

      <div className="relative w-full flex-none">
        <LogoMasthead rootClassName={"flex justify-center"} imgWidth={575} />
      </div>
    </Container>
  );
}
